(function () {
  var activeModal = null;

  function getGalleryItems(gallery) {
    var thumbnails = Array.prototype.slice.call(
      gallery.querySelectorAll("[data-tuya-gallery-thumbnail]"),
    );
    var openButton = gallery.querySelector("[data-tuya-gallery-open]");

    if (thumbnails.length) {
      return thumbnails.map(function (button) {
        return {
          trigger: button,
          image: button.getAttribute("data-tuya-gallery-image"),
          fullscreenImage:
            button.getAttribute("data-tuya-gallery-fullscreen-image") ||
            button.getAttribute("data-tuya-gallery-image"),
          alt: button.getAttribute("data-tuya-gallery-alt") || "",
        };
      });
    }

    if (!openButton) return [];

    return [
      {
        trigger: openButton,
        image: openButton.getAttribute("data-tuya-gallery-image"),
        fullscreenImage: openButton.getAttribute("data-tuya-gallery-image"),
        alt: openButton.getAttribute("data-tuya-gallery-alt") || "",
      },
    ];
  }

  function setActiveState(buttons, selectedIndex) {
    buttons.forEach(function (button, index) {
      var isActive = index === selectedIndex;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-current", isActive ? "true" : "false");
    });
  }

  function setGalleryImage(gallery, state, index) {
    var item = state.items[index];
    if (!item || !item.image) return;

    state.currentIndex = index;

    if (state.mainImage) {
      state.mainImage.classList.add("is-switching");
      setTimeout(function () {
        state.mainImage.removeAttribute("srcset");
        state.mainImage.src = item.image;
        state.mainImage.alt = item.alt;
        state.mainImage.classList.remove("is-switching");
      }, 150);
    }

    if (state.openButton) {
      state.openButton.setAttribute(
        "data-tuya-gallery-image",
        item.fullscreenImage || item.image,
      );
      state.openButton.setAttribute("data-tuya-gallery-alt", item.alt);
    }

    setActiveState(state.thumbnails, index);
    setActiveState(state.modalThumbnails, index);

    var activeThumb = state.thumbnails[index];
    var thumbsContainer = gallery.querySelector(
      "[data-tuya-gallery-thumbs-container]",
    );
    if (activeThumb && thumbsContainer) {
      var containerWidth = thumbsContainer.clientWidth;
      var thumbLeft = activeThumb.offsetLeft;
      var thumbWidth = activeThumb.clientWidth;
      var targetScrollLeft = thumbLeft - containerWidth / 2 + thumbWidth / 2;
      if (typeof thumbsContainer.scrollTo === "function") {
        thumbsContainer.scrollTo({
          left: targetScrollLeft,
          behavior: "smooth",
        });
      } else {
        thumbsContainer.scrollLeft = targetScrollLeft;
      }
    }

    if (state.modalImage) {
      state.modalImage.classList.add("is-switching");
      setTimeout(function () {
        state.modalImage.removeAttribute("srcset");
        state.modalImage.src = item.fullscreenImage || item.image;
        state.modalImage.alt = item.alt;
        state.modalImage.classList.remove("is-switching");
      }, 150);
    }
  }

  function openGalleryModal(gallery, state) {
    if (!state.modal || !state.items.length) return;

    state.lastFocusedElement = document.activeElement;
    if (state.modal.parentElement !== document.body) {
      document.body.appendChild(state.modal);
    }
    state.modal.hidden = false;
    gallery.classList.add("is-fullscreen-open");
    document.body.classList.add("tuya-gallery-modal-open");
    activeModal = { gallery: gallery, state: state };

    document.querySelectorAll('#MainContent, #header-group, footer').forEach(function(el) {
      el.setAttribute('inert', '');
    });

    setGalleryImage(gallery, state, state.currentIndex);

    var closeButton = state.modal.querySelector("[data-tuya-gallery-close]");
    if (closeButton && typeof closeButton.focus === "function") {
      closeButton.focus();
    }
  }

  function closeGalleryModal(gallery, state) {
    if (!state.modal || state.modal.hidden) return;

    state.modal.hidden = true;
    gallery.classList.remove("is-fullscreen-open");
    document.body.classList.remove("tuya-gallery-modal-open");
    activeModal = null;

    document.querySelectorAll('#MainContent, #header-group, footer').forEach(function(el) {
      el.removeAttribute('inert');
    });

    if (state.modal.parentElement !== gallery) {
      gallery.appendChild(state.modal);
    }

    if (
      state.lastFocusedElement &&
      typeof state.lastFocusedElement.focus === "function"
    ) {
      state.lastFocusedElement.focus();
    }
  }

  function moveGallery(gallery, state, direction) {
    if (!state.items.length) return;

    var nextIndex = state.currentIndex + direction;

    if (nextIndex < 0) {
      nextIndex = state.items.length - 1;
    }

    if (nextIndex >= state.items.length) {
      nextIndex = 0;
    }

    setGalleryImage(gallery, state, nextIndex);
  }

  function initGallery(gallery) {
    if (!gallery || gallery.dataset.tuyaGalleryReady === "true") return;

    var mainImage = gallery.querySelector(".tuya-product-gallery__image");
    var openButton = gallery.querySelector("[data-tuya-gallery-open]");
    var modal = gallery.querySelector("[data-tuya-gallery-modal]");
    var modalImage = gallery.querySelector(
      ".tuya-product-gallery__modal-image",
    );
    var thumbnails = Array.prototype.slice.call(
      gallery.querySelectorAll("[data-tuya-gallery-thumbnail]"),
    );
    var modalThumbnails = Array.prototype.slice.call(
      gallery.querySelectorAll("[data-tuya-gallery-modal-thumbnail]"),
    );
    var items = getGalleryItems(gallery);
    var activeIndex = thumbnails.findIndex(function (button) {
      return button.classList.contains("is-active");
    });

    if (!mainImage || !items.length) return;

    var state = {
      currentIndex: activeIndex >= 0 ? activeIndex : 0,
      items: items,
      lastFocusedElement: null,
      mainImage: mainImage,
      modal: modal,
      modalImage: modalImage,
      modalThumbnails: modalThumbnails,
      openButton: openButton,
      thumbnails: thumbnails,
    };

    gallery.dataset.tuyaGalleryReady = "true";
    setGalleryImage(gallery, state, state.currentIndex);

    thumbnails.forEach(function (button, index) {
      button.addEventListener("click", function () {
        setGalleryImage(gallery, state, index);
      });
    });

    modalThumbnails.forEach(function (button, index) {
      button.addEventListener("click", function () {
        setGalleryImage(gallery, state, index);
      });
    });

    if (openButton) {
      openButton.addEventListener("click", function () {
        openGalleryModal(gallery, state);
      });
    }

    if (modal) {
      modal
        .querySelectorAll("[data-tuya-gallery-close]")
        .forEach(function (button) {
          button.addEventListener("click", function () {
            closeGalleryModal(gallery, state);
          });
        });
    }

    var previousButton = modal
      ? modal.querySelector("[data-tuya-gallery-prev]")
      : null;
    var nextButton = modal
      ? modal.querySelector("[data-tuya-gallery-next]")
      : null;

    if (previousButton) {
      previousButton.addEventListener("click", function () {
        moveGallery(gallery, state, -1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener("click", function () {
        moveGallery(gallery, state, 1);
      });
    }

    var thumbsWrapper = gallery.querySelector(
      ".tuya-product-gallery__thumbs-wrapper",
    );
    var thumbsContainer = gallery.querySelector(
      "[data-tuya-gallery-thumbs-container]",
    );
    var thumbsPrevBtn = gallery.querySelector(
      "[data-tuya-gallery-thumbs-prev]",
    );
    var thumbsNextBtn = gallery.querySelector(
      "[data-tuya-gallery-thumbs-next]",
    );

    function updateThumbButtons() {
      if (
        !thumbsContainer ||
        !thumbsPrevBtn ||
        !thumbsNextBtn ||
        !thumbsWrapper
      )
        return;
      var scrollLeft = thumbsContainer.scrollLeft;
      var maxScroll = thumbsContainer.scrollWidth - thumbsContainer.clientWidth;

      var hasOverflow =
        thumbsContainer.scrollWidth > thumbsContainer.clientWidth;
      thumbsWrapper.classList.toggle("has-overflow", hasOverflow);

      thumbsPrevBtn.disabled = scrollLeft <= 1;
      thumbsNextBtn.disabled = scrollLeft >= maxScroll - 1;
    }

    if (thumbsContainer && thumbsPrevBtn && thumbsNextBtn) {
      thumbsPrevBtn.addEventListener("click", function () {
        var scrollAmount = thumbsContainer.clientWidth * 0.6;
        thumbsContainer.scrollBy({
          left: -scrollAmount,
          behavior: "smooth",
        });
      });

      thumbsNextBtn.addEventListener("click", function () {
        var scrollAmount = thumbsContainer.clientWidth * 0.6;
        thumbsContainer.scrollBy({
          left: scrollAmount,
          behavior: "smooth",
        });
      });

      thumbsContainer.addEventListener("scroll", updateThumbButtons);
      window.addEventListener("resize", updateThumbButtons);

      setTimeout(updateThumbButtons, 100);
    }
  }

  var lastScrollY = window.pageYOffset || document.documentElement.scrollTop;
  var stickyColumn = null;
  var stickyState = {
    currentTop: 0,
    columnHeight: 0,
    viewportHeight: 0,
    headerOffset: 0,
    isTaller: false,
    ticking: false
  };

  function updateStickySizes() {
    stickyColumn = document.querySelector(".tuya-main-product__column--right");
    if (!stickyColumn) return;

    stickyState.viewportHeight = window.innerHeight;
    stickyState.columnHeight = stickyColumn.offsetHeight;

    var headerHeight = parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--tuya-header-group-height')) || 60;
    stickyState.headerOffset = headerHeight + 16;
    stickyState.isTaller = stickyState.columnHeight > (stickyState.viewportHeight - stickyState.headerOffset);

    if (window.innerWidth <= 1024) {
      stickyColumn.style.position = "";
      stickyColumn.style.top = "";
    } else {
      stickyColumn.style.position = "sticky";
      if (!stickyState.isTaller) {
        stickyColumn.style.top = stickyState.headerOffset + "px";
        stickyState.currentTop = stickyState.headerOffset;
      }
    }
  }

  function handleStickyScroll() {
    if (!stickyColumn || window.innerWidth <= 1024) return;

    if (!stickyState.ticking) {
      window.requestAnimationFrame(function () {
        var scrollY = window.pageYOffset || document.documentElement.scrollTop;

        if (stickyState.isTaller) {
          var scrollDelta = scrollY - lastScrollY;
          var bottomLimit = stickyState.viewportHeight - stickyState.columnHeight - 24;
          var topLimit = stickyState.headerOffset;

          stickyState.currentTop = Math.max(bottomLimit, Math.min(topLimit, stickyState.currentTop - scrollDelta));
          stickyColumn.style.top = stickyState.currentTop + "px";
        }

        lastScrollY = scrollY;
        stickyState.ticking = false;
      });

      stickyState.ticking = true;
    }
  }

  window.addEventListener("scroll", handleStickyScroll, { passive: true });
  window.addEventListener("resize", function () {
    updateStickySizes();
    handleStickyScroll();
  }, { passive: true });

  function initMainProduct(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-tuya-gallery]").forEach(initGallery);
    updateStickySizes();
    handleStickyScroll();
  }

  document.addEventListener("keydown", function (event) {
    if (!activeModal) return;

    if (event.key === "Escape") {
      closeGalleryModal(activeModal.gallery, activeModal.state);
    }

    if (event.key === "ArrowLeft") {
      moveGallery(activeModal.gallery, activeModal.state, -1);
    }

    if (event.key === "ArrowRight") {
      moveGallery(activeModal.gallery, activeModal.state, 1);
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    initMainProduct(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initMainProduct(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    if (activeModal && event.target.contains(activeModal.gallery)) {
      if (activeModal.state.modal && activeModal.state.modal.parentElement) {
        activeModal.state.modal.parentElement.removeChild(
          activeModal.state.modal,
        );
      }
      activeModal = null;
      document.body.classList.remove("tuya-gallery-modal-open");
    }
  });
})();
